// London is this app's original, pre-multi-tenant city (GBP-based) - every
// other city tenant (Surat, Mumbai, etc.) uses Indian Rupees. Centralized
// here so the currency check stays consistent everywhere and in one place
// to update if that ever changes.
export const isLondonTenant = (user) => user?.tenant === 'london';

// £ for London, keeping its existing thousands-grouped format untouched;
// ₹ everywhere else, using simple 2-decimal formatting (no digit grouping).
export const currencySymbol = (user) => (isLondonTenant(user) ? '£' : '₹');

export const formatMoney = (user, value, decimals = 2) => {
  const num = parseFloat(value) || 0;
  if (isLondonTenant(user)) {
    return `£${num.toFixed(decimals).replace(/\B(?=(\d{3})+(?!\d))/g, ',')}`;
  }
  return `₹${num.toFixed(decimals)}`;
};
